import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Your Trusted Partner in
              <span className="highlight"> IT Solutions</span>
            </h1>
            <p className="hero-description">
              Professional IT Hardware, Network Maintenance, and Sales Services. 
              We provide comprehensive technology solutions to keep your business running smoothly.
            </p>
            <div className="hero-buttons">
              <a href="#services" className="btn btn-primary">Explore Services</a>
              <a href="/quote" className="btn btn-secondary">Get Quote</a>
            </div>
          </div>
          <div className="hero-image">
            <div className="hero-placeholder">
              {/*<div className="tech-icons">
                <div className="icon icon-color">&#x1F4BB;&#xFE0E;</div>
                <div className="icon icon-color">&#x1F4E1;&#xFE0F;</div>
                <div className="icon icon-color">&#127760;&#xFE0E;</div>
                <div className="icon icon-color">&#x1F6E1;&#xFE0E;</div>
              </div>
              <img className="hero-placeholder img" src="/images/IT_Support_Services_Overview.png" alt="Hero Image" />
              */}
              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
